import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import * as XLSX from "xlsx";
import "./DomainWiseRpt.css";

const API_URL = process.env.REACT_APP_API_URL || "https://api.transtrackglobal.in";


const DomainReport = () => {
  const [domains, setDomains] = useState([]);
  const [misData, setMisData] = useState(null);
  const [loading, setLoading] = useState(false);
  const userType = localStorage.getItem("userType") || "admin";

  const [filters, setFilters] = useState({
    year: "",
    month: "",
    domain: "",
  });

  /* ---------------- LOAD DOMAINS ---------------- */
  useEffect(() => {
    const fetchDomains = async () => {
      try {
        const res = await axios.get(`${API_URL}/api/domains`);
        setDomains(res.data);
      } catch (error) {
        console.error("Failed to load domain", error);
      }
    };
    fetchDomains();
  }, []);

  const years = ["2025", "2026"];
  const months = [
    { label: "January", value: 1 },
    { label: "February", value: 2 },
    { label: "March", value: 3 },
    { label: "April", value: 4 },
    { label: "May", value: 5 },
    { label: "June", value: 6 },
    { label: "July", value: 7 },
    { label: "August", value: 8 },
    { label: "September", value: 9 },
    { label: "October", value: 10 },
    { label: "November", value: 11 },
    { label: "December", value: 12 },
  ];

  /* ---------------- HANDLERS ---------------- */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const payload = {};
    if (filters.year) payload.year = Number(filters.year);
    if (filters.month) payload.month = Number(filters.month);
    if (filters.domain) payload.domain = filters.domain;

    const res = await axios.post(
      `${API_URL}/api/domainWiseRpt`,
      payload
    );

    setMisData(res.data.data);
    setLoading(false);
  };

  /* ---------------- EXCEL EXPORT ---------------- */
  const exportToExcel = () => {
    if (!misData) return;

    const exportData = [
      {
        "Active Resources": misData.activeResources ?? 0,
        "Monthly Billing": misData.monthlyBilling ?? 0,
        ...(userType !== "hr manager" ? {
          "Monthly Margin Amount": misData.monthlyMarginAmount ?? 0,
          "Monthly Margin %": misData.monthlyMarginPct ?? 0,
        } : {}),
      },
    ];

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Domain Report");

    XLSX.writeFile(workbook, "Domain_Wise_Report.xlsx");
  };

  /* ---------------- JSX ---------------- */
  return (
    <div className="mis-page">
      {/* HEADER */}
      <div className="mis-header">
        <h3 className="mis-title">Domain Report</h3>
        <Link to="/dashboard" className="btn outline-btn">
          <i className="bi bi-arrow-left"></i> Dashboard
        </Link>
      </div>

      {/* FILTER CARD */}
      <form className="mis-card" onSubmit={handleSubmit}>
        <div className="mis-grid">
          <div className="input-3d">
            <label>Year</label>
            <select name="year" value={filters.year} onChange={handleChange}>
              <option value="">Select</option>
              {years.map((y) => (
                <option key={y} value={y}>
                  {y}
                </option>
              ))}
            </select>
          </div>

          <div className="input-3d">
            <label>Month</label>
            <select name="month" value={filters.month} onChange={handleChange}>
              <option value="">Select</option>
              {months.map((m) => (
                <option key={m.value} value={m.value}>
                  {m.label}
                </option>
              ))}
            </select>
          </div>

          <div className="input-3d">
            <label>Domain</label>
            <select
              name="domain"
              value={filters.domain}
              onChange={handleChange}
            >
              <option value="">Select</option>
              {domains.map((d) => (
                <option key={d._id} value={d.name}>
                  {d.name}
                </option>
              ))}
            </select>
          </div>

          <div className="submit-3d">
            <button type="submit" className="btn gradient-btn">
              <i className="bi bi-bar-chart-line"></i> Generate
            </button>
          </div>
        </div>
      </form>

      {/* EXPORT BUTTON */}
      {misData && (
        <div style={{ margin: "15px 0", textAlign: "right" }}>
          <button className="btn gradient-btn" onClick={exportToExcel}>
            <i className="bi bi-file-earmark-excel"></i> Export Excel
          </button>
        </div>
      )}

      {/* ================= DOMAIN TABLE ================= */}
      {loading && <p>Loading Report...</p>}

      {misData && (
        <div className="table-scroll-wrapper">
          <table className="resource-table domain-table">
            <thead>
              <tr>
                <th>Active Resources</th>
                <th>Monthly Billing</th>
                {userType !== "hr manager" && (
                  <>
                    <th>Monthly Margin Amount</th>
                    <th>Monthly Margin %</th>
                  </>
                )}
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>{misData.activeResources ?? 0}</td>
                <td>{misData.monthlyBilling ?? 0}</td>
                {userType !== "hr manager" && (
                  <>
                    <td>{misData.monthlyMarginAmount ?? 0}</td>
                    <td>{misData.monthlyMarginPct ?? 0}</td>
                  </>
                )}
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default DomainReport;
